import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import { Carousel } from 'primereact/carousel';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import './Canje.css';
import { classNames } from 'primereact/utils';

const Canje = ({ cedula_empleado }) => {
    const [showDialog, setShowDialog] = useState(false);
    const [premiosDisponibles, setPremiosDisponibles] = useState([]);
    const [selectedPremio, setSelectedPremio] = useState(null);
    const [puntosDisponibles, setPuntosDisponibles] = useState(0);
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);
    const toast = useRef(null);
    const errorToast = useRef(null);

    useEffect(() => {
        fetch('/api/merito/premio/findall')
            .then(response => response.json())
            .then(data => {
                const premios = data.map(premio => ({
                    id: premio.id,
                    nombre: premio.nombre,
                    descripcion: premio.descripcion,
                    puntos: premio.puntos,
                    imagen: premio.imagen
                }));
                setPremiosDisponibles(premios);
            })
            .catch(error => console.error('Error fetching data:', error));
    }, []);

    useEffect(() => {
        if (cedula_empleado) {
            const obtenerPuntosDisponibles = () => {
                fetch(`/api/puntuacion/puntosporempleado/findbycedula/${cedula_empleado}`)
                    .then(response => response.json())
                    .then(data => {
                        setPuntosDisponibles(data);
                    })
                    .catch(error => console.error('Error fetching points:', error));
            };

            obtenerPuntosDisponibles();

            const intervalId = setInterval(obtenerPuntosDisponibles, 1000);
            return () => clearInterval(intervalId);
        }
    }, [cedula_empleado]);

    const handleCanjearClick = () => setShowDialog(true);
    const handleCancelarClick = () => setShowDialog(false);

    const handleReclamarPremioClick = () => {
        if (selectedPremio) {
            if (puntosDisponibles < selectedPremio.puntos) {
                const errorMessage = 'Puntos insuficientes para canjear este premio.';
                errorToast.current.show({ severity: 'error', summary: 'Error', detail: errorMessage, life: 3000 });
                setShowDialog(false);
                return;
            }

            const canjePremio = {
                empleado: { cedula: cedula_empleado },
                premio: { id: selectedPremio.id },
                fecha: new Date().toISOString().split('T')[0]
            };

            fetch('/api/puntuacion/canjepremio/canjear', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(canjePremio)
            })
                .then(response => {
                    if (!response.ok) {
                        return response.text().then(text => { throw new Error(text) });
                    }
                    return response.json();
                })
                .then(data => {
                    const { puntosRestantes } = data;

                    setPuntosDisponibles(puntosRestantes);
                    setShowDialog(false);
                    setShowSuccessDialog(true);

                    if (toast.current) {
                        toast.current.show({
                            severity: 'success',
                            summary: 'Premio reclamado',
                            detail: `Has reclamado tu premio ${selectedPremio.nombre} con éxito.`,
                            life: 3000
                        });
                    }

                    fetch(`/api/empleado/findall`)
                        .then(response => response.json())
                        .then(empleados => {
                            const empleado = empleados.find(emp => emp.cedula === cedula_empleado);
                            if (empleado) {
                                const correo = empleado.correo;

                                fetch('/email/enviar-correo', {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json'
                                    },
                                    body: JSON.stringify({
                                        destinatarios: [correo],
                                        asunto: 'Confirmación de Canje de Premio',
                                        cuerpo: `Estimado/a ${empleado.nombre}, \n\nLe informamos que ha realizado exitosamente el canje del premio\n"${selectedPremio.nombre}". Agradecemos su participación y esperamos que disfrute de su premio.\n\nSaludos cordiales,\n\nEquipo de Sistemas Manamer`
                                    })
                                })
                                    .then(response => {
                                        if (!response.ok) {
                                            return response.text().then(text => { throw new Error(text) });
                                        }
                                        console.log("Correo enviado con éxito");
                                    })
                                    .catch(error => {
                                        console.error("Error al enviar el correo:", error.message);
                                        if (errorToast.current) {
                                            errorToast.current.show({ severity: 'error', summary: 'Error', detail: error.message, life: 3000 });
                                        }
                                    });
                            } else {
                                console.error("Empleado no encontrado");
                                if (errorToast.current) {
                                    errorToast.current.show({ severity: 'error', summary: 'Error', detail: "Empleado no encontrado", life: 3000 });
                                }
                            }
                        })
                        .catch(error => {
                            console.error("Error al obtener el correo del empleado:", error.message);
                            if (errorToast.current) {
                                errorToast.current.show({ severity: 'error', summary: 'Error', detail: error.message, life: 3000 });
                            }
                        });
                })
                .catch(error => {
                    console.error("Error al canjear el premio:", error.message);
                    if (errorToast.current) {
                        errorToast.current.show({ severity: 'error', summary: 'Error', detail: error.message, life: 3000 });
                    }
                    setShowDialog(false);
                });
        }
    };

    const handleButtonClick = (product) => {
        setSelectedPremio(product);
        setShowDialog(true);
    };

    const productTemplate = (product) => {
        const isSelected = selectedPremio === product;

        return (
            <div className={`product-card surface-border border-round m-2 text-center py-5 px-3 ${isSelected ? 'selected' : ''}`}>
                <div className="product-image-container mb-3">
                    <img src={`${product.imagen}`} alt={product.nombre} className="product-image w-6 shadow-2" />
                </div>
                <div className="product-details">
                    <h4 className="product-title mb-1">{product.nombre}</h4>
                    <p className="product-description">{product.descripcion}</p>
                    <p className="product-points">Puntos requeridos: {product.puntos}</p>
                </div>
                <div className="product-action card flex flex-wrap justify-content-center gap-3">
                    <Button label="Canjear" severity="success" rounded className="p-button-primary smaller-button" onClick={() => handleButtonClick(product)} />
                </div>
            </div>
        );
    };

    return (
        <div className="p-grid p-dir-col">
            <div className="p-col">
                <div className="p-grid p-justify-between">
                    <div className="p-col-6">
                        <h2 style={{ color: '#0B3D91' }}>¡Canjea tus puntos por premios!</h2>
                    </div>
                </div>
                <div className="p-col mis-puntos-container">
                    <div className="mis-puntos-card">
                        <i className="pi pi-star mis-puntos-icon" />
                        <div className="mis-puntos-text">
                            <span className="mis-puntos-title">Mis puntos </span>
                            <span className="mis-puntos-value">{puntosDisponibles}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="p-col" style={{ height: '500px' }}>
                <Carousel value={premiosDisponibles} numVisible={1} numScroll={1} orientation="vertical" verticalViewPortHeight="400px" itemTemplate={productTemplate} />
            </div>

            <Dialog header={<div className="dialog-header-container"><i className="pi pi-check" style={{ marginRight: '5px' }}></i><span>Confirmación</span></div>} visible={showDialog} onHide={() => setShowDialog(false)} style={{ width: '300px' }}>
                <p>¿Está seguro de que desea canjear este premio?</p>
                <div className="dialog-buttons">
                    <Button label="Cancelar" className="p-button-text" onClick={handleCancelarClick} />
                    <Button label="Confirmar" className={classNames('p-button-danger')} onClick={handleReclamarPremioClick} />
                </div>
            </Dialog>

            <Dialog header={<div className="dialog-header-container"><i className="pi pi-info-circle" style={{ marginRight: '5px' }}></i><span>Información</span></div>} visible={showSuccessDialog} onHide={() => setShowSuccessDialog(false)} style={{ width: '300px', marginRight: '5px' }}>
                <p>Revisa tu correo electrónico. Se ha enviado la información completa para que puedas realizar el canje de tu premio.</p>
            </Dialog>

            <Toast ref={toast} position="top-right" />
            <Toast ref={errorToast} position="top-right" />
        </div>
    );
};

export default Canje;
